import { AHIcon, AHTeamIconRelay, AHText, AHTodoCategoryIcon, Box } from "arkh";
import React, { useCallback, useMemo } from "react";

import { graphql, useFragment, useLazyLoadQuery } from "react-relay";
import { RoutineOccasionIssueContainer } from "./RoutineOccasionIssue";
import { RoutineOccasionTodoIssueHighlightedQuery } from "./__generated__/RoutineOccasionTodoIssueHighlightedQuery.graphql";
import { RoutineOccasionTodoIssue_todo$key } from "./__generated__/RoutineOccasionTodoIssue_todo.graphql";
import { TodoSubjectIcon } from "widgets/src/WidgetTodoOverview/TodoSubject/TodoSubjectIcon";

import { Text } from "react-native";
import { TodoListItemHeaderWrapper } from "widgets/src/TodoListItem/TodoListItemHeader";

import { TodoListItem } from "@/src/components/TodoListItem";
export const RoutineOccasionTodoIssue = React.memo(
  InnerRoutineOccasionTodoIssue
);
function InnerRoutineOccasionTodoIssue(props: {
  isLast: boolean;
  isFirst: boolean;
  todo: RoutineOccasionTodoIssue_todo$key;
  disabled?: boolean;
  openTodo: (todoId: string) => void;
}) {
  const todo = useFragment(
    graphql`
      fragment RoutineOccasionTodoIssue_todo on Todo {
        id

        subject {
          ...TodoSubjectIcon_TodoSubject
        }
        teams {
          id
          ...AHTeamIcon
          color
        }
        category {
          isDefault
          icon
          title
        }

        ...TodoListItemHeaderWrapper_todo
        ...TodoListItem_todo
      }
    `,
    props.todo
  );
  const highlightedQuery =
    useLazyLoadQuery<RoutineOccasionTodoIssueHighlightedQuery>(
      graphql`
        query RoutineOccasionTodoIssueHighlightedQuery {
          store {
            activeIssueId
          }
        }
      `,
      {}
    );

  const header = useMemo(() => {
    return (
      <TodoListItemHeaderWrapper todo={todo}>
        {todo.subject ? (
          <Box
            style={{
              flexDirection: "row",
              alignItems: "center",
              flex: 1,
            }}
            spaceRight="small"
          >
            <TodoSubjectIcon subject={todo.subject} />
            <AHIcon
              type="arrow-right"
              color="text-secondary"
              size="xxsmall"
              spaceLeft="xsmall"
              spaceRight="small"
            />
            {todo.teams.length === 0 ? (
              <AHIcon type="store" size="small" color="washedText" />
            ) : (
              todo.teams.map((team, i) => (
                <AHTeamIconRelay
                  key={i + ""}
                  team={team}
                  customColor={team.color ?? undefined}
                  size="small"
                />
              ))
            )}
            {todo.category?.isDefault ? null : (
              <>
                <Box spaceLeft="small" style={{ flexShrink: 1 }}>
                  <Box
                    spaceHorizontal="small"
                    spaceVertical="xxsmall"
                    color="background"
                    cornerRadius="medium"
                    style={{
                      flexDirection: "column",
                    }}
                  >
                    <AHText
                      numberOfLines={1}
                      ellipsizeMode="tail"
                      type="subtitle"
                      color="text-secondary"
                      style={{
                        textAlign: "center",
                        alignContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <AHTodoCategoryIcon
                        spaceRight="none"
                        icon={todo.category?.icon ?? "Check"}
                        color="text-secondary"
                        size="small"
                      />
                      <Text> {todo.category?.title} </Text>
                    </AHText>
                  </Box>
                </Box>
              </>
            )}
          </Box>
        ) : null}
      </TodoListItemHeaderWrapper>
    );
  }, [todo]);

  const _openTodo = props.openTodo;
  const openTodo = useCallback(() => {
    _openTodo(todo.id);
  }, [_openTodo, todo.id]);

  return (
    <RoutineOccasionIssueContainer
      isFirst={props.isFirst}
      isLast={props.isLast}
    >
      <Box
        borderColor={
          highlightedQuery.store.activeIssueId &&
          todo.id === highlightedQuery.store.activeIssueId
            ? "primary"
            : "transparent"
        }
        cornerRadius="large"
        style={{ borderWidth: 1, padding: 1, margin: -1 }}
      >
        <TodoListItem
          isFirst
          isLast
          openTodo={openTodo}
          todo={todo}
          customHeader={header}
          disabled={props.disabled}
        />
      </Box>
    </RoutineOccasionIssueContainer>
  );
}
